(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["organism-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.js-organism-banner-video').forEach(function (root) {
    root.querySelectorAll('[data-banner-video-layer]').forEach(function (layer) {
      var video = layer.querySelector('video');
      var poster = layer.querySelector('.banner-video-poster');
      if (!video) return;
      if (layer.hasAttribute('data-banner-video-eager')) {
        video.preload = 'auto';
        video.setAttribute('loading', 'eager');
      }
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.play().catch(function () {});
      if (!poster) return;
      video.addEventListener(
        'playing',
        function () {
          poster.classList.add('banner-video-poster--hidden');
        },
        { once: true }
      );
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
